
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ranking",
      function () {
        return require("private-next-pages/ranking.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ranking"])
      });
    }
  